import {useState} from 'react'

// custom components
import AccordionBase from '../../../2compounds/AccordionBase'
import ContactCard from './ContactCard'

const ContactListView = ({data, handleChange, contactsCategorizedByContactType}) => {
    const [isOpen, setIsOpen] = useState(true)
    const {label, position} = data
    if(contactsCategorizedByContactType[label] === undefined) return ''

    // Note, filtering this because due to a race condition, we're getting objects
    // that are not contacts
    // XXX FIX ME
    const contactsGroupedByJobTitle = contactsCategorizedByContactType[label]?.filter(c => c.contact_id)
    const key = `${label}${position}`

    return (
        <AccordionBase key={key} label={label} data={data} isOpen={isOpen} setIsOpen={setIsOpen}>
            {
                contactsGroupedByJobTitle.map((contactData)=>{
                    const {contact_id} = contactData
                    const clickHandler = () =>handleChange(contactData)
                    return(
                        <div key={contact_id}>
                            <ContactCard data={contactData} clickHandler={clickHandler}/>
                        </div>
                    )
                })
            }
        </AccordionBase>
    )
}

export default ContactListView